<template>
  <v-row class="white" no-gutters justify="center">
    <v-card>
      <!-- <v-card-title class="headline">Payment Photo</v-card-title> -->
      <v-col cols="12">
      <v-img :src="file" height="100%" width="100%" contain v-on:error="onImgError"></v-img>
      </v-col>
      <v-col>
        <input type="file" id="file" ref="file" @change="changeImage" />
      </v-col>
      <v-card-actions>
        <v-btn depressed fab small class="mx-1" color="primary" outlined @click="clickViewPhoto()">
            <v-icon>visibility</v-icon>
          </v-btn>
        <!-- <v-btn depressed fab small class="mx-1" color="primary" outlined @click="clickDownloadPhoto()">
            <v-icon>cloud_download</v-icon>
          </v-btn> -->
        <v-spacer></v-spacer>
        <v-btn color=" darken-1" text @click="exist()">Cancel</v-btn>
        <v-btn color="primary darken-1" text @click="clickOrderPhoto()" outlined>SAVE</v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>
<script>
import axios from "../config";
import orderService from "../service/OrderService";
export default {
  data: () => ({
     file: "",
  }),
   props: {itemId:Number,transactionId:Number,notiId:Number,userAccountId:Number,photoIndex:String},
  mounted: function() {
    this.showPhoto();
  },
  methods: {
    onImgError : function(event) {
            this.file = "/info/logo.png";
        },
    showPhoto:function(){
    if(this.transactionId!=undefined && this.transactionId!=0){
      this.file  = `${axios.defaults.baseURL}/assigned/${this.transactionId}.png`;
    }else if(this.notiId!=undefined && this.notiId!=0){
        this.file  = `${axios.defaults.baseURL}/notiphoto/${this.notiId}.png`;
    }else if(this.userAccountId!=undefined && this.userAccountId!=0){
        this.file  = `${axios.defaults.baseURL}/rider/${this.userAccountId}.png`;
    }else{
      if(this.photoIndex=="item"){
        this.file  = `${axios.defaults.baseURL}/photos/${this.itemId}.png`;
      }else if(this.photoIndex=="gate"){
        this.file  = `${axios.defaults.baseURL}/gatevoucher/${this.itemId}.png`;
      }else if(this.photoIndex=="rest"){
        this.file  = `${axios.defaults.baseURL}/rest/${this.itemId}.png`;
        }else{
        this.file  = `${axios.defaults.baseURL}/itemsimple/${this.itemId}.png`;
      }
    }
    },
    clickViewPhoto:function(){
      window.open(this.file, "_blank");
    //     if(this.transactionId!=undefined && this.transactionId!=0){
    //   window.open(this.file, "_blank");
    // }else if(this.notiId!=undefined && this.notiId!=0){
    //     window.open(this.file, "_blank");
    // }else if(this.userAccountId!=undefined && this.userAccountId!=0){
    //     window.open(this.file, "_blank");
    // }else{
    //   if(this.photoIndex=="item"){
    //     window.open(this.file, "_blank");
    //   }else if(this.photoIndex=="gate"){
    //     window.open(this.file, "_blank");
    //   }else if(this.photoIndex=="rest"){
    //     window.open(this.file, "_blank");
    //     }else{
    //     window.open(this.file, "_blank");
    //   }
    // }
    },
    async  clickDownloadPhoto(){
    //const link = document.createElement("a");
      // link.href = `${axios.defaults.baseURL}/photos/${this.itemId}.png`;
      // link.setAttribute("download",""+this.itemId);
      // document.body.appendChild(link);
      // link.click();
      const a = document.createElement("a");
        a.href = await toDataURL(`${axios.defaults.baseURL}/photos/${this.itemId}.png`);
        a.download = "myImage.png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
      exist: function() {
        this.$refs.file.value=null;
        //this.file = "";
        //this.showPhoto();
      this.$emit("closeDialog");
    },
    changeImage: function(e) {
      let image = e.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.file = e.target.result;
      };
      
    },
    clickOrderPhoto:function(){
        this.$emit("closeDialog");
        var formData = new FormData();
      formData.append("file", this.$refs.file.files[0]);
      if(this.transactionId!=undefined && this.transactionId!=0){
        orderService
        .saveAssignedPhoto(formData,this.transactionId)
        .then((response) => {
          //this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }else if(this.notiId!=undefined && this.notiId!=0){
        orderService
        .saveNotiPhoto(formData,this.notiId)
        .then((response) => {
          //this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }else if(this.userAccountId!=undefined && this.userAccountId!=0){
        orderService
        .saveRiderPhoto(formData,this.userAccountId)
        .then((response) => {
          //this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }else{
        if(this.photoIndex=="item"){
        orderService
        .saveOrderPhoto(formData,this.itemId)
        .then((response) => {
          //this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }else if(this.photoIndex=="gate"){
        orderService
        .saveGateVoucher(formData,this.itemId)
        .then((response) => {
          //this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }else{
        orderService
        .saveItemSimple(formData,this.itemId)
        .then((response) => {
          //this.$swal("Successful","Save,Photo is Success.", "success");
          this.$swal({
     title: "Successful",
     text: "Save,Photo is Success.",
     type: "success",
     timer: 500
     });
        })
        .catch((error) => {
          this.$swal("Fail!", error.response.data.message, "error");
        });
      }
      
      }
    },

  },
  watch: {
    itemId:function(){
    //if(this.itemId!=undefined && this.itemId!=0){
        if(this.photoIndex=="item"){
        this.file  = `${axios.defaults.baseURL}/photos/${this.itemId}.png`;
      }else if(this.photoIndex=="gate"){
        this.file  = `${axios.defaults.baseURL}/gatevoucher/${this.itemId}.png`;
      }else if(this.photoIndex=="rest"){
        this.file  = `${axios.defaults.baseURL}/rest/${this.itemId}.png`;
        }else if(this.photoIndex == "assigned"){
            this.file  = `${axios.defaults.baseURL}/assigned/${this.transactionId}.png`;
        }else{
        this.file  = `${axios.defaults.baseURL}/itemsimple/${this.itemId}.png`;
      }
     // }
    },
    photoIndex:function(){
//if(this.itemId!=undefined && this.itemId!=0){
        if(this.photoIndex=="item"){
        this.file  = `${axios.defaults.baseURL}/photos/${this.itemId}.png`;
      }else if(this.photoIndex=="gate"){
        this.file  = `${axios.defaults.baseURL}/gatevoucher/${this.itemId}.png`;
      }else if(this.photoIndex=="rest"){
        this.file  = `${axios.defaults.baseURL}/rest/${this.itemId}.png`;
        }else if(this.photoIndex == "assigned"){
            this.file  = `${axios.defaults.baseURL}/assigned/${this.transactionId}.png`;
        }else{
        this.file  = `${axios.defaults.baseURL}/itemsimple/${this.itemId}.png`;
      }
     // }
    },
    // itemId:function(){
      
    // },
    transactionId:function(){
      if(this.transactionId!=undefined && this.transactionId!=0){
      this.file  = `${axios.defaults.baseURL}/assigned/${this.transactionId}.png`;
    }
    },
    notiId:function(){
      if(this.notiId!=undefined && this.notiId!=0){
      this.file  = `${axios.defaults.baseURL}/notiphoto/${this.notiId}.png`;
    }
    },
    userAccountId:function(){
      if(this.userAccountId!=undefined && this.userAccountId!=0){
      this.file  = `${axios.defaults.baseURL}/rider/${this.userAccountId}.png`;
    }
    }
  },
  components: {}
};
</script>
<style scoped>

</style>
      // eslint-disable-next-line
      /* eslint-disable */ 